import React from 'react';
import { 
  HelpCircle, 
  Database, 
  Clock, 
  DollarSign, 
  Server, 
  Scale, 
  Shield, 
  Zap 
} from 'lucide-react';

const BestPracticesSidebar = () => {
  const tips = [
    {
      icon: DollarSign,
      title: 'Оптимизация бюджета',
      description: 'Используйте зарезервированные инстансы для долгосрочных проектов, это снизит затраты до 70%.'
    },
    {
      icon: Clock,
      title: 'Поэтапное внедрение',
      description: 'Разбейте проект на фазы, начиная с MVP. Это снизит риски и ускорит получение результатов.'
    },
    {
      icon: Scale,
      title: 'Масштабирование',
      description: 'Проектируйте архитектуру с учетом роста данных на 3-5 лет вперед.'
    },
    {
      icon: Server,
      title: 'Гибридные решения',
      description: 'Комбинируйте локальное хранилище для критичных данных и облако для остальных задач.'
    },
    {
      icon: Shield,
      title: 'Безопасность',
      description: 'Внедряйте многоуровневую защиту и шифрование данных на всех этапах обработки.'
    },
    {
      icon: Zap,
      title: 'Оптимизация запросов',
      description: 'Используйте материализованные представления и оптимизацию запросов для ускорения аналитики.'
    },
    {
      icon: Database,
      title: 'Управление данными',
      description: 'Внедрите политики жизненного цикла данных для автоматического перемещения в более дешевые хранилища.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-indigo-500" />
        Лучшие практики Big Data
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-indigo-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <HelpCircle className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-blue-700 dark:text-blue-300 mb-2">
              Бесплатная консультация
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400 mb-3">
              Получите профессиональную консультацию по оптимизации вашего Big Data проекта от наших экспертов.
            </p>
            <button className="w-full py-1.5 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors">
              Запросить консультацию
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BestPracticesSidebar;